import { z } from "zod";

export const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
] as const;

// TanStack Router parses search values as JSON, so `?gclid=123` arrives as the
// number 123 and a strict `z.string()` would throw and bubble up as a 500.
// Coerce primitives to strings and fall back to undefined for anything else
// (objects, arrays) so malformed tracking params never crash the app.
const looseString = z
  .union([z.string(), z.number(), z.boolean()])
  .transform(String)
  .optional()
  .catch(undefined);

export const rootSearchSchema = z.object({
  from: looseString,
  utm_source: looseString,
  utm_medium: looseString,
  utm_campaign: looseString,
  utm_content: looseString,
  utm_term: looseString,
  gclid: looseString,
});
